import PropTypes from "prop-types";
import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {Paragraph} from "BaseComponents/Text/";
import {HeaderLinkStyle} from "BaseComponents/Link/BaseLink";
import {Link} from "BaseComponents/Link";
import {FlexContainer} from "BaseComponents/Flex/";

export const ImageWrapper = styled.div`
    min-width: 284px;
    width: 100%;
    display: flex;
    height: ${({isPopup}) => (isPopup ? "auto" : "160px")};
    border-bottom-right-radius: ${({isPopup, theme}) => (isPopup ? theme.border.radius : "")};
    border-top-right-radius: ${({theme}) => theme.border.radius};
    border-top-left-radius: ${({isPopup, theme}) => (!isPopup ? theme.border.radius : "")};
    border: 1px solid grey;
    border-bottom: none;
    background-image: ${({bgImage}) => (bgImage ? `url(${bgImage})` : "")};
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
`;
export const BackroundImage = styled.div`
    height: 160px;
    border-bottom-right-radius: ${({isPopup, theme}) => (isPopup ? theme.border.radius : "")};
    border-top-right-radius: ${({theme}) => theme.border.radius};
    border-top-left-radius: ${({isPopup, theme}) => (!isPopup ? theme.border.radius : "")};
    border: 1px solid grey;
    border-bottom: none;

    width: 100%;
`;

export const CardsWrapper = styled(FlexContainer)`
    ${media.lessThan(breakpoints.small)`
	div{
		width: ${({isPopup}) => !isPopup && "100%"};
	}
	`}
    div {
        ${({useGrid}) =>
                useGrid &&
                css`
                {
                    flex-wrap: wrap;
                    flex-basis: calc(100% / 4 - (15px * 3 / 4));
                    ${media.lessThan(breakpoints.ipadPlus)`
						flex-basis: calc(100% / 3 - (15px * 2 / 3));
				`}
                    ${media.lessThan(breakpoints.mobile)`
						flex-basis: calc(100% / 2 - (15px * 1 / 2));
				`}
                    ${media.lessThan(breakpoints.small)`
						flex-basis: 100%;
				`}
                `}
    }
`;

export const P = styled(Paragraph)`
    && {
        display: flex;
        align-items: center;

        font-size: 15px;
        margin: ${({margin}) => margin ? margin : '5px'};

        i {
            ::before {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
`;
export const Info = styled.div`
    height: 100%;
`;

export const Letter = styled(Paragraph)`
    & {
        display: block;
        width: ${({width}) => width ? width : '75vw'};
        font-size: 20px;
        margin: 1rem 1.2rem;
        font-weight: bold;
    }
`;

export const AddressWrapper = styled.div`
    && {
        display: flex;
        font-size: 15px;
        margin: 5px;
        align-items: baseline;
    }
`;

export const AddressTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const AddressLink = styled(Link)`
    margin: 2px 0 0 0;
`;

export const ColorWrapper = styled.div`
    background-color: ${({theme}) => theme.colors.lightgreen};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 40px;
`;

export const BottomWrapper = styled.div`
    overflow: visible;
    display: flex;
    align-items: center;

    height: ${({height}) => (height ? height : "")};
    border-bottom-left-radius: ${({theme}) => theme.border.radius};
    border-bottom-right-radius: ${({isPopup, theme}) => (!isPopup ? theme.border.radius : "")};

    ${media.lessThan(breakpoints.mobile)`
		border-bottom-right-radius: ${({isPopup, theme}) => (isPopup ? theme.border.radius : "")};

  `}
`;
export const Icon = styled.i`
    color: ${({theme, color}) => (color ? color : theme.colors.primary)};
    margin-right: 5px;
`;
export const TopWrapper = styled.div`
    padding: 0.5rem;
    border-bottom: ${({theme}) => `2px solid ${theme.colors.primary}`};

    ${Icon}:before {
        font-size: 20px;
    }
`;
export const TextSpan = styled.span`
    font-size: 14px;
    display: flex;
    color: black;
    align-items: center;
`;
export const InnerWrapper = styled.div`
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
`;
export const OuterWrapper = styled.div`
    display: flex;
    margin: ${({isPopup}) => (isPopup ? "0" : "14px")};
    flex-direction: ${({isPopup}) => (isPopup ? "row" : "column-reverse")};

    ${media.lessThan(breakpoints.small)`
	margin: ${({isPopup}) => (isPopup ? "20px 0 0" : "14px 0")};
	padding: ${({isPopup}) => (isPopup ? "0" : "0 10px")};

`}
`;

export const OuterNameWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
`;

export const CardWrapper = styled.div`
    & {
        ${({isPopup}) =>
                isPopup
                        ? {
                            margin: 0,
                            border: 0,
                            maxWidth: "unset",
                        }
                        : {
                            border: "1px solid #949494",
                            maxWidth: "280px",
                        }}
    }

    ${media.lessThan(breakpoints.small)`
	max-width: unset;
`}
    & {
        height: 100%;
        border-bottom-left-radius: ${({theme}) => theme.border.radius};
        border-top-left-radius: ${({isPopup, theme}) => (isPopup ? theme.border.radius : "")};
        border-bottom-right-radius: ${({isPopup, theme}) =>
                !isPopup ? theme.border.radius : ""};

        ${media.lessThan(breakpoints.mobile)`
		border-bottom-right-radius: ${({isPopup, theme}) => (isPopup ? theme.border.radius : "")};
		border-top-right-radius: ${({isPopup, theme}) => (isPopup ? theme.border.radius : "")};

  `}
        background-color: ${({theme}) => theme.colors.white};
        display: flex;
        flex-direction: column;
        outline: none;
        transition: all 0.2s ease;
        min-height: ${({maxHeight}) => {
            maxHeight ? maxHeight : "220px";
        }};
        flex-basis: 30%;
        min-width: 284px;
    }

    &:hover,
    &:focus {
        ${HeaderLinkStyle} {
            span {
                border-color: black;
            }
        }
    }
`;

export const ClosePopup = styled.button.attrs(({ariaLabel}) => ({
    "aria-label": ariaLabel || "close button",
}))`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
    top: -15px;
    right: -20px;
    z-index: 1;
    border: 0;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;

    &:hover {
        background: #000;

        span {
            background: #fff;
        }
    }

    &:focus {
        outline-offset: 5px;
        outline: ${({theme}) => theme.colors.primaryDark} solid 2px;
    }
`

export const CrossIconItem = styled.span`
    position: absolute;
    width: 17px;
    height: 2px;
    background: #000;
    transform: rotate(${({rotate}) => rotate});
    border-radius: 5px;
`
